<template>
    <div class="worldcup-page">
        <div class="worldcup-page__header" v-if="$device.isMobileOrTablet">
            <n-link class="back" to="/">
                <img :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/icon-back.png`" alt="box">
            </n-link>
        </div>
        <BannerWheel />
        <div v-if="!$device.isMobileOrTablet"  class="worldcup-background">
            <SectionSlots />
            <SectionTabs :tabs="worldCupTabs" />
            <SectionPromotion />
        </div>
        <template v-if="$device.isMobileOrTablet">
            <DailyWinnerMB />
            <MenuMobile v-model="menuActive" />
            <PrizeSection v-if="indexComponent===0" @ShowComponent="ShowComponent" @hideComponent="hideComponent" />
            <TopRancingSection v-if="indexComponent===1" @hideComponent="hideComponent" />
            <EarnTurnSection v-if="indexComponent===2" @hideComponent="hideComponent" />
            <HistoryRuleSection v-if="indexComponent===3" @hideComponent="hideComponent" />
        </template>
    </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import $ from 'jquery';
import BannerWheel from './banner-wheel.vue';
// eslint-disable-next-line import/no-unresolved
import SectionSlots from '~/components/event/worldcup/section-slots.vue';
// eslint-disable-next-line import/no-unresolved
import SectionTabs from '~/components/event/worldcup/section-tabs.vue';
// eslint-disable-next-line import/no-unresolved
import TabPrize from '~/components/event/worldcup/tabs/prize.vue';
// eslint-disable-next-line import/no-unresolved
import TabRule from '~/components/event/worldcup/tabs/rule.vue';
// eslint-disable-next-line import/no-unresolved
import TabEarnTurn from '~/components/event/worldcup/tabs/earn-turn.vue';
// eslint-disable-next-line import/no-unresolved
import TabConditions from '~/components/event/worldcup/tabs/conditions.vue';
// eslint-disable-next-line import/no-unresolved
import TabHistory from '~/components/event/worldcup/tabs/history.vue';
// eslint-disable-next-line import/no-unresolved
import SectionPromotion from '~/components/event/worldcup/promotion.vue';
// eslint-disable-next-line import/no-unresolved
import DailyWinnerMB from '~/components/event/worldcup/daily-winner-mb.vue';
// eslint-disable-next-line import/no-unresolved
import MenuMobile from '~/components/event/worldcup/menu-mobile.vue';
// eslint-disable-next-line import/no-unresolved
import PrizeSection from '~/components/event/worldcup/mobile/prize.vue';
// eslint-disable-next-line import/no-unresolved
import TopRancingSection from '~/components/event/worldcup/mobile/top-rancing.vue';
// eslint-disable-next-line import/no-unresolved
import EarnTurnSection from '~/components/event/worldcup/mobile/earn-turn.vue';
// eslint-disable-next-line import/no-unresolved
import HistoryRuleSection from '~/components/event/worldcup/mobile/history-rule.vue';

export default {
    components: {
        BannerWheel,
        SectionSlots,
        SectionTabs,
        SectionPromotion,
        DailyWinnerMB,
        MenuMobile,
        PrizeSection,
        TopRancingSection,
        EarnTurnSection,
        HistoryRuleSection
    },
    watch: {
        menuActive(value) {
            this.ShowComponent(value);
        }
    },
    methods: {
        ShowComponent(index) {
            this.indexComponent = index;
        },
        hideComponent() {
            this.indexComponent = -1;
            this.menuActive = -1;
        },
        async getSpinsCount() {
            if (this.currentUser) {
                try {
                    const { data: { turnAvailable } } = await this.$seaGameApi.spinsCount(this.currentUser.username);
                    this.$store.commit('mutate', {
                        property: 'spinsCount',
                        with: turnAvailable
                    });
                } catch (e) {
                    this.formError = e.message;
                }
            }
        },
        async getUserTurn() {
            try {
                const res = await this.$worldCupWheelApi.userTurn();
                // this.$store.commit('mutate', {
                //     property: 'spinsCount',
                //     with: turnAvailable
                // });
                console.log(res);
            } catch (e) {
                this.formError = e.message;
            }
        },
        async roll() {
            try {
                const res = await this.$worldCupWheelApi.roll(10);
                // this.$store.commit('mutate', {
                //     property: 'spinsCount',
                //     with: turnAvailable
                // });
                console.log(res);
            } catch (e) {
                this.formError = e.message;
            }
        }
    },
    computed: {
        currentUser() {
            return this.$store.state.user;
        }
    },
    data() {
        return {
            isDisabled: true,
            indexComponent: -1,
            menuActive: -1,
            worldCupTabs: [
                {
                    title: 'GIẢI THƯỞNG',
                    isActive: true,
                    component: TabPrize
                },
                {
                    title: 'THỂ LỆ',
                    isActive: false,
                    component: TabRule
                },
                {
                    title: 'kiếm lượt chơi',
                    isActive: false,
                    component: TabEarnTurn
                },
                {
                    title: 'điều kiện thưởng',
                    isActive: false,
                    component: TabConditions
                },
                {
                    title: 'Lịch sử quay',
                    isActive: false,
                    component: TabHistory,
                    isRequiredLogin: true
                }
            ]
        };
    },
    mounted() {
        this.$nextTick(async () => {
            // await this.getUserTurn();
            // await this.roll();
        });
    }

};
</script>
